const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      borderRadius: '8px',
      boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.25)',
      zIndex: 999
    },
    overlay: {
      backgroundColor: 'rgba(255, 255, 255, 0.55)',
      zIndex: 999
    }
  };
export default customStyles;

export const phoneModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: '8px',
    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.25)',
    zIndex: 999
  },
  overlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.55)',
    zIndex: 999
  }
};

export const customMobileStyles = {
  content: {
    position: "absolute",
    bottom: "0",
    top: "auto",
    left: "auto",
    right: "auto",
    border: 'none',
    background: 'rgb(255, 255, 255)',
    overflow: 'auto',
    borderRadius: 'none',
    outline: 'none',
    padding: '20px',
    boxShadow: '0px -5px 7px 0px rgba(0, 0, 0, 0.25)',
    width: '94.8vw',
    zIndex: 999
  },
  overlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.55)',
    zIndex: 999
  }
}

export const customMobileStylesForCart = {
  content: {
    position: "absolute",
    bottom: "0",
    top: "auto",
    left: "auto",
    right: "auto",
    border: 'none',
    background: 'rgb(255, 255, 255)',
    overflow: 'auto',
    borderRadius: 'none',
    outline: 'none',
    padding: '14px',
    boxShadow: '0px -8px 20px 0px rgba(0, 0, 0, 0.10)',
    width: '100%'
  }  
}